import React from 'react';
import {
  Link,
  Stack,
  TableCell, TableRow,
} from '@material-ui/core';

import { CommonMoreMenu } from '../../../components';
import { BecomePartner } from '../../../types';
import { fDate } from '../../../utils';
import { useOnItemClick } from '../../../hooks/useOnItemClick';

export const BecomePartnerItem: React.FC<{
  data: BecomePartner
}> = ({ data }) => {
  const { onItemClick } = useOnItemClick('/dashboard/become-partner', data.id);

  return (
    <TableRow hover sx={{ cursor: 'pointer' }}>
      <TableCell onClick={onItemClick}>{data.id}</TableCell>
      <TableCell onClick={onItemClick}>{data.contactPersonName}</TableCell>
      <TableCell onClick={onItemClick}>{data.companyName}</TableCell>
      <TableCell onClick={onItemClick}>{`${data.country}, ${data.city}`}</TableCell>
      <TableCell onClick={onItemClick}>{data.phoneNumber}</TableCell>
      <TableCell onClick={onItemClick}>{data.email}</TableCell>
      <TableCell
        onClick={onItemClick}
        sx={{
          maxWidth: 200,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {data.websiteUrl}
      </TableCell>

      <TableCell>
        <Stack direction="column" spacing={1}>
          {data.attachments?.map((att) => (
            <Link
              key={att.id}
              href={att.file}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: 'block', maxWidth: 120, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}
            >
              {att.file.split('/').pop()}
            </Link>
          ))}
        </Stack>
      </TableCell>
      <TableCell onClick={onItemClick} sx={{ minWidth: 120 }}>
        {fDate(data.createdAt)}
      </TableCell>
      <TableCell align="right">
        <CommonMoreMenu
          itemId={data.id}
          updatingLink="/dashboard/become-partner"
        />
      </TableCell>
    </TableRow>
  );
};
